/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsSyncDashboardStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncDashboardStatusQuery = { pdsSyncStatus: { __typename: 'PdsSyncStatus', health?: { __typename: 'PdsSyncHealth', health: string, details?: any | null, updatedAt?: string | null } | null, events: Array<{ __typename: 'PdsSyncEvent', type: string, title: string, detail?: string | null, metadata?: any | null, createdAt: string } | { __typename: 'PdsSyncEventGroup', type: string, count: number, timeRangeFrom: string, timeRangeTo: string, metadata?: any | null }>, workflowState?: { __typename: 'PdsSyncWorkflowState', heartbeatIntervalS: number, tier1SyncIntervalS: number, paused: boolean, pauseReason?: string | null, dirtyFlag: string, fullSyncDirty: boolean, heartbeatNumber: number, lastHeartbeatAt?: string | null, totalHitCount: number, maxDbId: number, apiStatus: string, apiVersion?: string | null, apiVersionStatus: string, apiVersionRevision?: string | null, tier1Running: boolean, tier1Count: number, tier1LastCompletedAt?: string | null, tier1LastDurationS?: number | null, tier1LastChanges?: number | null, tier1TotalBatches: number, tier1CompletedBatches: number, tier1CompositionAngebote: number, tier1CompositionAuftraege: number, tier1CompositionRechnungen: number, tier1CompositionBestellungen: number, tier1CompositionKunden: number, fullSyncRunning: boolean, fullSyncLastCompletedAt?: string | null, lastFullSyncDate?: string | null, cursorAngeboteCount: number, cursorAngeboteDelta: number, cursorAuftraegeCount: number, cursorAuftraegeDelta: number, cursorRechnungenCount: number, cursorRechnungenDelta: number, cursorBestellungenCount: number, cursorBestellungenDelta: number, heartbeatCalls: Array<{ __typename: 'PdsSyncHeartbeatCall', name: string, status: string, durationMs?: number | null }> } | null } };

export type PdsSyncTriggerHeartbeatMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncTriggerHeartbeatMutation = { triggerPdsSyncHeartbeat: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncTriggerTier1MutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncTriggerTier1Mutation = { triggerPdsSyncTier1: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncCancelTier1MutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncCancelTier1Mutation = { cancelPdsSyncTier1: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncTriggerFullSyncMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncTriggerFullSyncMutation = { triggerPdsSyncFullSync: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncCancelFullSyncMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncCancelFullSyncMutation = { cancelPdsSyncFullSync: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncPauseMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncPauseMutation = { pausePdsSync: { __typename: 'PdsSyncControlResult', ok: boolean } };

export type PdsSyncResumeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncResumeMutation = { resumePdsSync: { __typename: 'PdsSyncControlResult', ok: boolean } };


export const PdsSyncDashboardStatusDocument = gql`
    query PdsSyncDashboardStatus {
  pdsSyncStatus {
    health {
      health
      details
      updatedAt
    }
    events {
      ... on PdsSyncEvent {
        type
        title
        detail
        metadata
        createdAt
      }
      ... on PdsSyncEventGroup {
        type
        count
        timeRangeFrom
        timeRangeTo
        metadata
      }
    }
    workflowState {
      heartbeatIntervalS
      tier1SyncIntervalS
      heartbeatCalls {
        name
        status
        durationMs
      }
      paused
      pauseReason
      dirtyFlag
      fullSyncDirty
      heartbeatNumber
      lastHeartbeatAt
      totalHitCount
      maxDbId
      apiStatus
      apiVersion
      apiVersionStatus
      apiVersionRevision
      tier1Running
      tier1Count
      tier1LastCompletedAt
      tier1LastDurationS
      tier1LastChanges
      tier1TotalBatches
      tier1CompletedBatches
      tier1CompositionAngebote
      tier1CompositionAuftraege
      tier1CompositionRechnungen
      tier1CompositionBestellungen
      tier1CompositionKunden
      fullSyncRunning
      fullSyncLastCompletedAt
      lastFullSyncDate
      cursorAngeboteCount
      cursorAngeboteDelta
      cursorAuftraegeCount
      cursorAuftraegeDelta
      cursorRechnungenCount
      cursorRechnungenDelta
      cursorBestellungenCount
      cursorBestellungenDelta
    }
  }
}
    `;

/**
 * __usePdsSyncDashboardStatusQuery__
 *
 * To run a query within a React component, call `usePdsSyncDashboardStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncDashboardStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncDashboardStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncDashboardStatusQuery(baseOptions?: Apollo.QueryHookOptions<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>(PdsSyncDashboardStatusDocument, options);
      }
export function usePdsSyncDashboardStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>(PdsSyncDashboardStatusDocument, options);
        }
export function usePdsSyncDashboardStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>(PdsSyncDashboardStatusDocument, options);
        }
export type PdsSyncDashboardStatusQueryHookResult = ReturnType<typeof usePdsSyncDashboardStatusQuery>;
export type PdsSyncDashboardStatusLazyQueryHookResult = ReturnType<typeof usePdsSyncDashboardStatusLazyQuery>;
export type PdsSyncDashboardStatusSuspenseQueryHookResult = ReturnType<typeof usePdsSyncDashboardStatusSuspenseQuery>;
export type PdsSyncDashboardStatusQueryResult = Apollo.QueryResult<PdsSyncDashboardStatusQuery, PdsSyncDashboardStatusQueryVariables>;
export const PdsSyncTriggerHeartbeatDocument = gql`
    mutation PdsSyncTriggerHeartbeat {
  triggerPdsSyncHeartbeat {
    ok
  }
}
    `;
export type PdsSyncTriggerHeartbeatMutationFn = Apollo.MutationFunction<PdsSyncTriggerHeartbeatMutation, PdsSyncTriggerHeartbeatMutationVariables>;

/**
 * __usePdsSyncTriggerHeartbeatMutation__
 *
 * To run a mutation, you first call `usePdsSyncTriggerHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncTriggerHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncTriggerHeartbeatMutation, { data, loading, error }] = usePdsSyncTriggerHeartbeatMutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncTriggerHeartbeatMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncTriggerHeartbeatMutation, PdsSyncTriggerHeartbeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncTriggerHeartbeatMutation, PdsSyncTriggerHeartbeatMutationVariables>(PdsSyncTriggerHeartbeatDocument, options);
      }
export type PdsSyncTriggerHeartbeatMutationHookResult = ReturnType<typeof usePdsSyncTriggerHeartbeatMutation>;
export type PdsSyncTriggerHeartbeatMutationResult = Apollo.MutationResult<PdsSyncTriggerHeartbeatMutation>;
export type PdsSyncTriggerHeartbeatMutationOptions = Apollo.BaseMutationOptions<PdsSyncTriggerHeartbeatMutation, PdsSyncTriggerHeartbeatMutationVariables>;
export const PdsSyncTriggerTier1Document = gql`
    mutation PdsSyncTriggerTier1 {
  triggerPdsSyncTier1 {
    ok
  }
}
    `;
export type PdsSyncTriggerTier1MutationFn = Apollo.MutationFunction<PdsSyncTriggerTier1Mutation, PdsSyncTriggerTier1MutationVariables>;

/**
 * __usePdsSyncTriggerTier1Mutation__
 *
 * To run a mutation, you first call `usePdsSyncTriggerTier1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncTriggerTier1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncTriggerTier1Mutation, { data, loading, error }] = usePdsSyncTriggerTier1Mutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncTriggerTier1Mutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncTriggerTier1Mutation, PdsSyncTriggerTier1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncTriggerTier1Mutation, PdsSyncTriggerTier1MutationVariables>(PdsSyncTriggerTier1Document, options);
      }
export type PdsSyncTriggerTier1MutationHookResult = ReturnType<typeof usePdsSyncTriggerTier1Mutation>;
export type PdsSyncTriggerTier1MutationResult = Apollo.MutationResult<PdsSyncTriggerTier1Mutation>;
export type PdsSyncTriggerTier1MutationOptions = Apollo.BaseMutationOptions<PdsSyncTriggerTier1Mutation, PdsSyncTriggerTier1MutationVariables>;
export const PdsSyncCancelTier1Document = gql`
    mutation PdsSyncCancelTier1 {
  cancelPdsSyncTier1 {
    ok
  }
}
    `;
export type PdsSyncCancelTier1MutationFn = Apollo.MutationFunction<PdsSyncCancelTier1Mutation, PdsSyncCancelTier1MutationVariables>;

/**
 * __usePdsSyncCancelTier1Mutation__
 *
 * To run a mutation, you first call `usePdsSyncCancelTier1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncCancelTier1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncCancelTier1Mutation, { data, loading, error }] = usePdsSyncCancelTier1Mutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncCancelTier1Mutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncCancelTier1Mutation, PdsSyncCancelTier1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncCancelTier1Mutation, PdsSyncCancelTier1MutationVariables>(PdsSyncCancelTier1Document, options);
      }
export type PdsSyncCancelTier1MutationHookResult = ReturnType<typeof usePdsSyncCancelTier1Mutation>;
export type PdsSyncCancelTier1MutationResult = Apollo.MutationResult<PdsSyncCancelTier1Mutation>;
export type PdsSyncCancelTier1MutationOptions = Apollo.BaseMutationOptions<PdsSyncCancelTier1Mutation, PdsSyncCancelTier1MutationVariables>;
export const PdsSyncTriggerFullSyncDocument = gql`
    mutation PdsSyncTriggerFullSync {
  triggerPdsSyncFullSync {
    ok
  }
}
    `;
export type PdsSyncTriggerFullSyncMutationFn = Apollo.MutationFunction<PdsSyncTriggerFullSyncMutation, PdsSyncTriggerFullSyncMutationVariables>;

/**
 * __usePdsSyncTriggerFullSyncMutation__
 *
 * To run a mutation, you first call `usePdsSyncTriggerFullSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncTriggerFullSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncTriggerFullSyncMutation, { data, loading, error }] = usePdsSyncTriggerFullSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncTriggerFullSyncMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncTriggerFullSyncMutation, PdsSyncTriggerFullSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncTriggerFullSyncMutation, PdsSyncTriggerFullSyncMutationVariables>(PdsSyncTriggerFullSyncDocument, options);
      }
export type PdsSyncTriggerFullSyncMutationHookResult = ReturnType<typeof usePdsSyncTriggerFullSyncMutation>;
export type PdsSyncTriggerFullSyncMutationResult = Apollo.MutationResult<PdsSyncTriggerFullSyncMutation>;
export type PdsSyncTriggerFullSyncMutationOptions = Apollo.BaseMutationOptions<PdsSyncTriggerFullSyncMutation, PdsSyncTriggerFullSyncMutationVariables>;
export const PdsSyncCancelFullSyncDocument = gql`
    mutation PdsSyncCancelFullSync {
  cancelPdsSyncFullSync {
    ok
  }
}
    `;
export type PdsSyncCancelFullSyncMutationFn = Apollo.MutationFunction<PdsSyncCancelFullSyncMutation, PdsSyncCancelFullSyncMutationVariables>;

/**
 * __usePdsSyncCancelFullSyncMutation__
 *
 * To run a mutation, you first call `usePdsSyncCancelFullSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncCancelFullSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncCancelFullSyncMutation, { data, loading, error }] = usePdsSyncCancelFullSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncCancelFullSyncMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncCancelFullSyncMutation, PdsSyncCancelFullSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncCancelFullSyncMutation, PdsSyncCancelFullSyncMutationVariables>(PdsSyncCancelFullSyncDocument, options);
      }
export type PdsSyncCancelFullSyncMutationHookResult = ReturnType<typeof usePdsSyncCancelFullSyncMutation>;
export type PdsSyncCancelFullSyncMutationResult = Apollo.MutationResult<PdsSyncCancelFullSyncMutation>;
export type PdsSyncCancelFullSyncMutationOptions = Apollo.BaseMutationOptions<PdsSyncCancelFullSyncMutation, PdsSyncCancelFullSyncMutationVariables>;
export const PdsSyncPauseDocument = gql`
    mutation PdsSyncPause {
  pausePdsSync {
    ok
  }
}
    `;
export type PdsSyncPauseMutationFn = Apollo.MutationFunction<PdsSyncPauseMutation, PdsSyncPauseMutationVariables>;

/**
 * __usePdsSyncPauseMutation__
 *
 * To run a mutation, you first call `usePdsSyncPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncPauseMutation, { data, loading, error }] = usePdsSyncPauseMutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncPauseMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncPauseMutation, PdsSyncPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncPauseMutation, PdsSyncPauseMutationVariables>(PdsSyncPauseDocument, options);
      }
export type PdsSyncPauseMutationHookResult = ReturnType<typeof usePdsSyncPauseMutation>;
export type PdsSyncPauseMutationResult = Apollo.MutationResult<PdsSyncPauseMutation>;
export type PdsSyncPauseMutationOptions = Apollo.BaseMutationOptions<PdsSyncPauseMutation, PdsSyncPauseMutationVariables>;
export const PdsSyncResumeDocument = gql`
    mutation PdsSyncResume {
  resumePdsSync {
    ok
  }
}
    `;
export type PdsSyncResumeMutationFn = Apollo.MutationFunction<PdsSyncResumeMutation, PdsSyncResumeMutationVariables>;

/**
 * __usePdsSyncResumeMutation__
 *
 * To run a mutation, you first call `usePdsSyncResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncResumeMutation, { data, loading, error }] = usePdsSyncResumeMutation({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncResumeMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncResumeMutation, PdsSyncResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncResumeMutation, PdsSyncResumeMutationVariables>(PdsSyncResumeDocument, options);
      }
export type PdsSyncResumeMutationHookResult = ReturnType<typeof usePdsSyncResumeMutation>;
export type PdsSyncResumeMutationResult = Apollo.MutationResult<PdsSyncResumeMutation>;
export type PdsSyncResumeMutationOptions = Apollo.BaseMutationOptions<PdsSyncResumeMutation, PdsSyncResumeMutationVariables>;